interface domainMap {
  [key: string]: number
}

const priceCapPerCountry: domainMap = {
  DK: 100,
  FR: 100,
  PT: 100,
  NO: 100,
  BE: 100,
  AU: 110,
  IT: 100,
  PL: 100,
}

const priceCapPerDomain: domainMap = {
  'fr-FR': 100,
  'fr-BE': 100,
  'fr-CH': 100,
  'it-IT': 100,
  'nl-BE': 100,
  'en-AU': 110,
}

const priceCap = (locale?: string | null, countryCode?: string): number => {
  if (locale) {
    const priceCapDomain = priceCapPerDomain[locale]

    if (priceCapDomain) return priceCapDomain
  }

  if (countryCode) {
    const priceCap = priceCapPerCountry[countryCode]
    if (priceCap) return priceCap
  }

  return 120
}

export default priceCap
